<template>
  <div class="main">
    <base-card v-for="side in sides" :key="side.name">
      <v-card-title>{{ side.name }}</v-card-title>
      <v-card-actions class="flex text-right"><v-spacer></v-spacer>{{ side.price }}</v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sides: [
        {
          name: "Pomfrit",
          price: "60/80 den.",
        },
        {
          name: "Ajkë",
          price: "20/30 den.",
        },
        {
          name: "Kërpudha",
          price: "30/40 den.",
        },
        {
          name: "Kaçkavall",
          price: "30/40 den.",
        },
        {
          name: "Sallamë pule",
          price: "30/40 den.",
        },
        {
          name: "Lepinje",
          price: "30 den.",
        },
        {
          name: "Kulen",
          price: "60 den.",
        },
        {
          name: "Proshut",
          price: "60 den.",
        },
        {
          name: "Pleskavic",
          price: "100 den.",
        },
        {
          name: "Stek pule",
          price: "110 den.",
        },
        {
          name: "Të ndara",
          price: "30 den.",
        },
        {
          name: "Cesar salcë",
          price: "20 den.",
        },
        {
          name: "Mjete për ushqim",
          price: "10 den.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 200vh;
  background: transparent;
}
</style>
